import { S2_PREFIX_CLS } from '../../common/constant/classnames';

export const DRILL_DOWN_PRE_CLASS = `${S2_PREFIX_CLS}-drill-down`;

export const STRATEGY_SHEET_TOOLTIP_PRE_CLASS = `${S2_PREFIX_CLS}-strategy-sheet-tooltip`;
